import IdentityClient from "./IdentityClient";
import { Constants } from "../../constants/constants";
import { IPagedList } from "../../commons/interfaces";


const UserService = {

    async getPaged(data: any): Promise<IPagedList<any>> {
        const result = await IdentityClient().get(
            `${Constants.ApiPath.USER.GET_PAGED}?${data}`
        );
        return result.data.result;
    },

}

export default UserService;